import {
    DISPLAY_ALERT,
    CLEAR_ALERT,
    LOGIN_USER_BEGIN,
    LOGIN_USER_ERROR,
    LOGIN_USER_SUCCESS,
    TOGGLE_SIDEBAR,
    LOGOUT_USER,
    UPDATE_USER_BEGIN,
    UPDATE_USER_ERROR,
    UPDATE_USER_SUCCESS,
    HANDLE_CHANGE,
    CLEAR_VALUES,
    CREATE_INFORMATION_ITEM_BEGIN,
    CREATE_INFORMATION_ITEM_ERROR,
    CREATE_INFORMATION_ITEM_SUCCESS,
    GET_INFORMATION_ITEMS_BEGIN,
    GET_INFORMATION_ITEMS_SUCCESS,
    SET_EDIT_INFORMATION_ITEM,
    DELETE_INFORMATION_ITEM_BEGIN,
    EDIT_INFORMATION_ITEM_BEGIN,
    EDIT_INFORMATION_ITEM_SUCCESS,
    EDIT_INFORMATION_ITEM_ERROR,
    CLEAR_FILTERS,
    CHANGE_PAGE,
    CHANGE_MONTH_TO_DISPLAY,
    CHANGE_ROW,
    CHANGE_SHOW_LOGOUT,
} from "./actions";

import { initialState } from "./appContext";

const reducer = (state, action) => {
    if (action.type === DISPLAY_ALERT) {
        return {
            ...state,
            showAlert: true,
            alertType: 'danger',
            alertText: action.text
        }
    }

    if (action.type === CLEAR_ALERT) {
        return {
            ...state,
            showAlert: false,
            alertType: '',
            alertText: ''
        }
    }

    if (action.type === LOGIN_USER_BEGIN) {
        return { ...state, isLoading: true }
    }

    if (action.type === LOGIN_USER_SUCCESS) {
        return {
            ...state,
            isLoading: false,
            token: action.payload.token,
            user: action.payload.user,
            userLocation: action.payload.location,
            jobLocation: action.payload.location,
            showAlert: true,
            alertType: 'success',
            alertText: 'Login Successful! Redirecting...'
        }
    }

    if (action.type === LOGIN_USER_ERROR) {
        return {
            ...state,
            isLoading: false,
            showAlert: true,
            alertType: 'danger',
            alertText: action.payload.msg
        }
    }

    if (action.type === TOGGLE_SIDEBAR) {
        return {
            ...state,
            showSidebar: !state.showSidebar,
        }
    }

    if (action.type === LOGOUT_USER) {
        return {
            ...initialState,
            user: null,
            token: null,
            userLocation: '',
            jobLocation: ''

        }
    }

    if (action.type === UPDATE_USER_BEGIN) {
        return { ...state, isLoading: true }
    }

    if (action.type === UPDATE_USER_SUCCESS) {
        return {
            ...state,
            isLoading: false,
            token: action.payload.token,
            user: action.payload.user,
            userLocation: action.payload.location,
            jobLocation: action.payload.location,
            showAlert: true,
            alertType: 'success',
            alertText: 'User Profile Updated!'
        }
    }

    if (action.type === UPDATE_USER_ERROR) {
        return {
            ...state,
            isLoading: false,
            showAlert: true,
            alertType: 'danger',
            alertText: action.payload.msg
        }
    }

    if (action.type === HANDLE_CHANGE) {
        return {
            ...state,
            [action.payload.name]: action.payload.value
        }
    }

    if (action.type === CLEAR_VALUES) {
        const initialState = {
            isEditing: false,
            editInformationItemId: '',
            year: new Date().getFullYear(),
            // attention js uses January as 0 to December as 11
            // backend is selfimplemented and uses the german way (jan as 1 to dec as 12)
            month: new Date().getMonth() + 1,
            electricity: '',
            commentElectricity: '',
            photovoltaic: '',
            commentPhotovoltaic: '',
            water: '',
            commentWater: '',
            heating: '',
            commentHeating: '',
        }
        return { ...state, ...initialState }
    }

    if (action.type === CREATE_INFORMATION_ITEM_BEGIN) {
        return { ...state, isLoading: true }
    }

    if (action.type === CREATE_INFORMATION_ITEM_SUCCESS) {
        return {
            ...state,
            isLoading: false,
            showAlert: true,
            alertType: 'success',
            alertText: 'New Information Item Created!'
        }
    }

    if (action.type === CREATE_INFORMATION_ITEM_ERROR) {
        return {
            ...state,
            isLoading: false,
            showAlert: true,
            alertType: 'danger',
            alertText: action.payload.msg
        }
    }

    if (action.type === GET_INFORMATION_ITEMS_BEGIN) {
        return {
            ...state,
            isLoading: true,
            showAlert: false
        }
    }

    if (action.type === GET_INFORMATION_ITEMS_SUCCESS) {
        return {
            ...state,
            isLoading: false,
            informationItems: action.payload.informationItems,
            totalInformationItems: action.payload.totalInformationItems
        }
    }

    if (action.type === SET_EDIT_INFORMATION_ITEM) {
        const informationItem = state.informationItems.find((item) => item._id === action.payload.id);
        const {
            _id
        } = informationItem;
        return {
            ...state,
            isEditing: true,
            editInformationItemId: _id,
        }
    }

    if (action.type === DELETE_INFORMATION_ITEM_BEGIN) {
        return { ...state, isLoading: true }
    }

    if (action.type === EDIT_INFORMATION_ITEM_BEGIN) {
        return {
            ...state,
            isLoading: true,
        }
    }

    if (action.type === EDIT_INFORMATION_ITEM_SUCCESS) {
        return {
            ...state,
            isLoading: false,
            showAlert: true,
            alertType: 'success',
            alertText: 'Information Item Updated!'
        }
    }

    if (action.type === EDIT_INFORMATION_ITEM_ERROR) {
        return {
            ...state,
            isLoading: false,
            showAlert: true,
            alertType: 'danger',
            alertText: action.payload.msg
        }
    }

    if (action.type === CLEAR_FILTERS) {
        return {
            ...state,
            search: '',
            sort: 'DESC',
        }
    }

    if (action.type === CHANGE_PAGE) {
        return { ...state, yearToDisplay: action.payload.yearToDisplay }
    }

    if (action.type === CHANGE_MONTH_TO_DISPLAY){
        return { ...state, monthToDisplay: action.payload.monthToDisplay }
    }

    if (action.type === CHANGE_ROW) {
        return { ...state, rowToDisplay: action.payload.rowToDisplay }
    }

    if (action.type === CHANGE_SHOW_LOGOUT) {
        return { ...state, showLogout: action.payload.showLogout }
    }

    throw new Error(`no such action: ${action.type}`);
}

export default reducer;